import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseOrdersReport } from "../UseOrdersReport";
import { UseMyPC } from "../../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../../components/CustomPagination";
import { toMoney } from "../../../util/Utils";
import BubbleChart1 from "./BubbleChart1";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function PaymentGrid(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetPaymentDetails } = UseOrdersReport();
  const [detailRes, setDetailRes] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.startDate && props.endDate) {
      GetPaymentDetails(props.startDate, props.endDate, (callback) => {
        setDetailRes(callback);
      });
    }
  }, [props.startDate, props.endDate]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "نوع پرداخت",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.name}
          </Typography>
        );
      },
    },
    {
      field: "orderCount",
      headerName: "تعداد",
      width: 85,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.orderCount ? toMoney(cellValues.row.orderCount) : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalOrginalCost",
      headerName: "مجموع کل",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalOrginalCost
              ? toMoney(cellValues.row.totalOrginalCost)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "مجموع پرداخت",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalDiscount",
      headerName: "تخفیف",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalDiscount
              ? toMoney(cellValues.row.totalDiscount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalDiscountPercent",
      headerName: "درصد تخفیف",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalDiscountPercent
              ? toMoney(cellValues.row.totalDiscountPercent)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalCredit",
      headerName: "اعتباری",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.totalCredit
              ? toMoney(cellValues.row.totalCredit)
              : 0}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box
      sx={{
        height: "80%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          bgcolor: "secondary.main",
          p: 1,
          borderRadius: 1,
        }}
      >
        <ArrowCircleLeftIcon
          sx={{ mr: 0.5, fill: "#fff" }}
          //   fontSize="small"
        />
        <Typography color="#fff" variant="subitle1">
          نوع پرداخت
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          mb: 5,
          height: "100%",
        }}
      >
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={detailRes ? detailRes.items : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={
            detailRes && detailRes.items && detailRes.items.length
              ? detailRes.items.length
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              rowCount:
                detailRes && detailRes.items && detailRes.items.length
                  ? detailRes.items.length
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />
        {!isSmall && (
          <BubbleChart1 items={detailRes && detailRes.graph}></BubbleChart1>
        )}
      </Box>
    </Box>
  );
}
